<section style="padding-bottom: 3px;margin-top: 120px;">
    <div class="container" data-aos="fade-up">
        <div class="row">
            <div class="col-lg-12">
                <h1 class="theme_color">
                    <strong>Online Training</strong>
                </h1>

                <p class="theme_color fontSize">
                    SFI Compliance, Inc. has partnered with Red Vector to provide online safety training. Red Vector is
                    an
                    OSHA authorized online training provider. This partnership allows us to provide quality online
                    training
                    for those who cannot make it to a live class.
                </p>

                <p class="theme_color fontSize">
                    <strong><a href="https://sficompliance.redvector.com/default.aspx" target="_blank"
                            class="theme_color"><u>Online Classes</u></a></strong>
                </p>
            </div>
        </div>
    </div>
</section>

<section style="margin-top: -4%;">
    <div class="container">
        <div class="row">
            <div class="col-lg-4" data-aos="fade-right" data-aos-delay="300" style="padding-top: 20px;">
                <img src="../../assets/images/Training.jpg" class="img-fluid" alt="" /><br />
            </div>
            <div class="col-lg-8" data-aos="fade-left" data-aos-delay="300" style="padding-top: 20px;">
                <h1 class="theme_color">
                    <strong>On Site Training</strong>
                </h1>

                <p class="theme_color fontSize">Schedule a date and time with us based on your availability to host a
                    job site safety training at your
                    location. Save on time and gas and have us host the training at your site.

                <h2 class="theme_color">
                    <strong>Personalized classes based on needs: </strong>
                </h2>

                <p class="theme_color fontSize">Need safety training but don’t see the class you need listed? <a
                        href="/contact">Contact us</a> now to
                    schedule a personalized training class based on your needs. We offer a wide range of classes like
                    forklift
                    re/certification, mobile elevated work platform certification, fall protection awareness, rigger
                    signal
                    person training, scaffold competent person and many more!
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4" data-aos="fade-right" data-aos-delay="300">
                <img src="../../assets/images/training room.JPG" class="img-fluid pt-5" alt="" />
            </div>
            <div class="col-lg-8" data-aos="fade-left" data-aos-delay="300" style="padding-top: 20px;">
                <h1 class="theme_color mt-4">
                    <strong>We also offer room rentals!</strong>
                </h1>

                <p class="theme_color fontSize">
                    Need a space for your next corporate meeting? We offer our training room for rent hourly or for the
                    day. Contact us for more information or to get a quote!
                </p>

                <p class="theme_color fontSize">
                    Email us at <a href="mailto:customerservice@sficompliance.com">customerservice@sficompliance.com</a>
                    to schedule your next training today!
                </p>

            </div>
        </div>
    </div>
</section>